import { render, staticRenderFns } from "./EntityActions.vue?vue&type=template&id=68d39f16&scoped=true"
import script from "./EntityActions.vue?vue&type=script&lang=js"
export * from "./EntityActions.vue?vue&type=script&lang=js"
import style0 from "./EntityActions.vue?vue&type=style&index=0&id=68d39f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d39f16",
  null
  
)

export default component.exports